import { render, staticRenderFns } from "./DialogPdfAdobe.vue?vue&type=template&id=a2b4a5e0"
import script from "./DialogPdfAdobe.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogPdfAdobe.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports